import { ENDPOINTS } from "../endpoints";

/** GET /api/statusS */
export const getProjectStatus = async () => {
    const response = await fetch(ENDPOINTS.STATUS.GET, {
        method: "GET",
        headers: { Accept: "application/json" },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return {
        usersCount: Number(data.usersCount ?? 0),
        charactersCount: Number(data.charactersCount ?? 0),
    };
};
